import Inferno from "inferno";
import { Router, Route, IndexRoute } from "inferno-router";
import createBrowserHistory from "history/createBrowserHistory";
import FontFaceObserver from "fontfaceobserver";
import "./index.css";
import App from "./App";
import Home from "./Home";
import Contacts, { CONTACTS } from "./Contacts";
import Datacenter from "./Datacenter";
import Datacenters, { DATACENTER, DATACENTERS } from "./Datacenters";
import Services, { SERVICES } from "./Services";
import ReactGA from "react-ga";

ReactGA.initialize( "UA-61275319-2" ); // HARD-CODED

const browserHistory = createBrowserHistory();


function NoMatch( { children } ) {
   return <div>NoMatch</div>;
}


// HARD-CODED
const routes = (
   <Router history={browserHistory}>
      <Route component={App}>
         <IndexRoute component={Home} />
         <Route path={CONTACTS} component={Contacts} />
         <Route path={DATACENTERS} component={Datacenters} />
         <Route path={`/${DATACENTER}/:id`} component={Datacenter} />
         <Route path={SERVICES} component={Services} />
         <Route path="*" component={NoMatch} />
      </Route>
   </Router>
);

const fontFaceObserver = new FontFaceObserver( "SpaceAge" );

fontFaceObserver.load().then( () => {
   Inferno.render( routes, document.getElementById( "app" ) ); // HARD-CODED in conjunction with index.html
} );



// WEBPACK FOOTER //
// ./src/index.js